// 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
import React, {useEffect, useRef, useState} from 'react';
import Recorder from 'recorder-js';
import "./App.css"

export default function WhisperUploader({onResult, onStart, disabled}) {

    const [recording, setRecording] = useState(false);
    const [loading, setLoading] = useState(false);
    const audioContextRef = useRef(null);
    const recorderRef = useRef(null);
    const streamRef = useRef(null);

    useEffect(() => {
        return () => {
            if (streamRef.current) {
                streamRef.current.getTracks().forEach((track) => track.stop());
            }
        };
    }, []);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({audio: true});
            streamRef.current = stream;

            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            if (!AudioContextClass) {
                alert("AudioContext non supporté.");
                return;
            }

            onStart();
            const audioContext = new AudioContextClass();
            audioContextRef.current = audioContext;

            const recorder = new Recorder(audioContext);
            await recorder.init(stream);
            await recorder.start();
            recorderRef.current = recorder;

            setRecording(true);
        } catch (err) {
            console.error('WHISPER Erreur micro :', err);
            alert("Erreur lors de l'accès au micro.");
        }
    };

    const stopRecording = async () => {
        try {
            setLoading(true);
            const {blob} = await recorderRef.current.stop();
            setRecording(false);

            const formData = new FormData();
            formData.append('file', blob, 'audio.wav');
            formData.append('model', 'whisper-1');
            formData.append('language', 'he');

            const fetchWithTimeout = (url, options = {}, timeout = 3000) => {
                return Promise.race([
                    fetch(url, options),
                    new Promise((_, reject) =>
                        setTimeout(() => reject(new Error('Timeout exceeded')), timeout)
                    ),
                ]);
            };

            const response = await fetchWithTimeout('https://api.openai.com/v1/audio/transcriptions', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer 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`, // Remplace par ta vraie clé
                },
                body: formData,
            }, 15000); // 15 secondes max

            const data = await response.json();
            onResult(data.text || 'Désolé aucune transcription')
        } catch (err) {
            console.error('WHISPER Erreur transcription :', err);
            onResult('Désolé délai de transcription dépassé')
        } finally {
            setLoading(false);
        }
    };

    const handleClick = () => {
        if (recording) {
            stopRecording();
        } else {
            startRecording();
        }
    };


    return (
            <button
                onClick={handleClick}
                disabled={loading || disabled}
                className={"button-secondary audio-btn"}
            >
                {loading ? (
                    <span className="spinner" />
                ) : (
                    recording ? '⏹️' : '🎙️'
                )}
            </button>
    );
}



